app.service('productCardPromotions', function (_, modal, productCardConfig, productPromotionsListModal) {
	let $self;
	let config;

	function init() {
		config = productCardConfig.getData();
		setElements();
		if ($self.length) {// dodawany jest w kodzie na podstawie zmiennej z backendu "${existAnyStandardPromotion}"
			setCmsPromotionBlock();
			setEvents();
		}
	}

	function setElements() {
		$self = $('#product-promotions');
	}

	function setEvents() {
		$self.on('click', '.js-more-promotions', openPromotionsModal);
		$self.on('click', '.promotion-item', function() {
			UA.interaction('KP_Crossell', 'Sekcja_promocyjna_' + _.escapeDiacritics($(this).find('.title').text()).trim()
			.split(' ').join('_'), 'Klikniecie');
		})
	}

	function openPromotionsModal() {
		productPromotionsListModal.show(
			config.id
		);
		UA.interaction('KP_Crossell', 'Sekcja_promocyjna_wiecej', 'Klikniecie');
	}

	function fetchCmsPromotions() {
		return $.ajax({
			url: '/web-cached/cms-promotion-block-section.ltr',
			data: {
				productId: config.id
			}
		});
	}

	function setCmsPromotionBlock() {
		$self.addClass('loading');
		fetchCmsPromotions().then(function (html) {
			renderCmsPromotionsBlock(html);
		}).fail(function () {
			modal.alert("[Promocje CMS] Błąd pobierania.");
		}).always(function () {
			$self.removeClass('loading');
		});
	}

	function renderCmsPromotionsBlock(html) {
		$self.html(html);
	}

	return {
		init: init
	};
});